// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_d2-0";